import React, { useState, useEffect, forwardRef, Ref, useImperativeHandle } from 'react';
import { Input } from '@fx-ui/fine-design';
import { isEmpty, forEach } from '~/utils';
import Intl from '@fx-ui/intl';

interface IReceiptInputProps {
    placeholder?: string;
    style?: any;
    allowBlank?: boolean;
    value?: string;
    inputType?: string;
    regex?: string;
    onChange?: (value: string, e?: React.ChangeEvent) => void;
}

const ReceiptInput: React.ForwardRefRenderFunction<HTMLDivElement, IReceiptInputProps> = (
    props,
    ref: Ref<any>
) => {
    const { placeholder, style, allowBlank = true, value, inputType, regex = '', onChange } = props;
    const [inputValue, setInputValue] = useState<string>('');
    const [inputState, setInputState] = useState<'error' | 'normal'>('normal');
    const [inputError, setInputError] = useState<string>('');

    const proofFields = ['contact_name', 'contact_phone', 'account_name', 'account_no'];

    useImperativeHandle(ref, () => {
        return {
            validateInputState,
            resetInputState
        };
    });

    useEffect(() => {
        setInputValue(value!);
    }, [value]);

    const validateInputState = () => {
        let valid = true;
        let isPayProof = false;
        forEach(proofFields, (fieldName) => {
            if (fieldName === inputType) {
                isPayProof = true;
                return;
            }
        });
        if (!allowBlank) {
            if (isEmpty(inputValue)) {
                valid = false;
                setInputState('error');
                setInputError(isPayProof ? '' : Intl.get('item.required'));
            } else {
                if (isEmpty(regex)) {
                    resetInputState();
                } else {
                    valid = new RegExp(regex).test(inputValue);
                    if (valid) {
                        resetInputState();
                    } else {
                        setInputState('error');
                        switch (inputType) {
                            case 'tax_number':
                                setInputError(Intl.get('receipt.taxNo.required'));
                                break;
                            case 'receiver_email':
                                setInputError(Intl.get('email.invalid.warning'));
                                break;
                            case 'receiver_phone':
                                setInputError(Intl.get('phone.invalid.warning'));
                                break;
                            default:
                                break;
                        }
                    }
                }
            }
        }
        return valid;
    };

    const resetInputState = () => {
        setInputState('normal');
        setInputError('');
    };

    return (
        <>
            <Input
                style={style}
                placeholder={placeholder}
                value={inputValue}
                onChange={(value: string) => {
                    setInputValue(value);
                    onChange && onChange(value);
                }}
                onBlur={validateInputState}
                inputState={inputState}
            />
            {inputState === 'error' && <div className="input-error-tip">{inputError}</div>}
        </>
    );
};

export default forwardRef(ReceiptInput);
